import {
  Spaceable
} from "./chunk.G3SZKTQJ.js";
import {
  Rt
} from "./chunk.LTAMHVKK.js";
import {
  jbLinkClickedEventToJbTrackingEvent
} from "./chunk.ABOYTYJO.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  h,
  ke
} from "./chunk.FCKNEYTX.js";
import {
  n
} from "./chunk.BBN2ZB42.js";
import {
  i,
  r
} from "./chunk.FAJKIEWS.js";
import {
  __decorateClass
} from "./chunk.I4IFG4JG.js";

// src/components/jb-text-with-image/jb-text-with-image.scss?inline
var jb_text_with_image_default = i`*,
*::before,
*::after {
  box-sizing: border-box;
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

/* COLOR SETTINGS */
/* shadows */
:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
/* stylelint-disable */
/* stylelint-enable */
:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
article {
  --_grid-gap: 16px;
  --_grid-template-columns: repeat(12, 1fr);
  display: grid;
  gap: var(--grid-row-gap, 0) var(--grid-column-gap, var(--_grid-gap));
  grid-template-columns: var(--theme-grid-template-columns, var(--_grid-template-columns));
  width: 100%;
}
@media (min-width: 960px) {
  article {
    --_grid-gap: 40px;
  }
}

:host {
  color: var(--host-color, #141e55);
}

:host {
  --_imagewidth: 4;
  --_columnstart: 2;
  --image-caption-font-size: 0.813rem;
  --image-caption-line-height: 1.25rem;
  --paragraphs-margin-left: 0;
  --paragraphs-margin-right: 0;
  --image-caption-margin-top: var(--spacing-2xs);
  --image-credit-margin-top: 0;
}

article {
  grid-column: main;
}

jb-image {
  grid-column: 1/13;
  margin-block-end: var(--spacing-l);
}

.slotwrapper {
  grid-column: 1/13;
}

@media (min-width: 960px) {
  .small {
    --_columnstart: 3;
    --_imagewidth: 3;
  }
  .small .slotwrapper {
    grid-column: calc(var(--_columnstart) + var(--_imagewidth))/span calc(8 - var(--_imagewidth));
  }
  .landscape.large {
    --_imagewidth: 5;
  }
  .portrait.large {
    --_imagewidth: 4;
  }
  jb-image {
    grid-column: var(--_columnstart)/span var(--_imagewidth);
  }
  .slotwrapper {
    grid-column: calc(var(--_columnstart) + var(--_imagewidth))/span calc(9 - var(--_imagewidth));
  }
  .end,
  .right {
    --_columnstart: 3;
  }
  .end jb-image,
  .right jb-image {
    grid-row: 1;
    order: 2;
  }
  .end .slotwrapper,
  .right .slotwrapper {
    grid-row: 1;
    order: 1;
  }
  .end.large jb-image,
  .right.large jb-image {
    grid-column: calc(13 - var(--_imagewidth) - 1)/span var(--_imagewidth);
  }
  .end.large .slotwrapper,
  .right.large .slotwrapper {
    grid-column: var(--_columnstart)/span calc(9 - var(--_imagewidth));
  }
  .end.small jb-image,
  .right.small jb-image {
    grid-column: calc(13 - var(--_imagewidth) - 2)/span var(--_imagewidth);
  }
  .end.small .slotwrapper,
  .right.small .slotwrapper {
    grid-column: var(--_columnstart)/span calc(8 - var(--_imagewidth));
  }
}`;

// src/components/jb-text-with-image/jb-text-with-image.ts
var JbTextWithImage = class extends Spaceable(h) {
  _getContentSpacingProperties() {
    return {
      colsMdUp: 12,
      type: "text"
    };
  }
  _tracking(e) {
    const jbTrackingEvent = jbLinkClickedEventToJbTrackingEvent(e, {
      component_name: "text-with-image"
    });
    if (jbTrackingEvent) {
      this.dispatchEvent(jbTrackingEvent);
    }
  }
  render() {
    return ke`
      <article
        class="${Rt({
      [this.imageAlign]: true,
      [this.imageOrientation]: true,
      [this.imageSize]: true
    })}"
      >
        <jb-image
          .caption=${this.image.caption}
          .credit=${this.image.credit}
          .picture=${this.image.picture}
          .text=${this.image.text}
        ></jb-image>
        <div class="slotwrapper">
          <slot @jb-link:clicked=${this._tracking}></slot>
        </div>
      </article>
    `;
  }
};
JbTextWithImage.styles = r(jb_text_with_image_default);
__decorateClass([
  n({ type: Object })
], JbTextWithImage.prototype, "image", 2);
__decorateClass([
  n()
], JbTextWithImage.prototype, "imageAlign", 2);
__decorateClass([
  n()
], JbTextWithImage.prototype, "imageOrientation", 2);
__decorateClass([
  n()
], JbTextWithImage.prototype, "imageSize", 2);
JbTextWithImage = __decorateClass([
  customElement("jb-text-with-image")
], JbTextWithImage);

export {
  JbTextWithImage
};
